import React from 'react'

import { useFiltersContext } from '@contexts/FilterContext'

import MenuIcon from '@components/Icons/Menu'
import CloseIcon from '@components/Icons/Close'

import styles from './styles.module.css'

const FilterToggle = () => {
  const { showFilters, toggleShowFilters } = useFiltersContext()

  return (
    <button aria-label='Toggle Filters' className={styles.toggle} onClick={toggleShowFilters}>
      {showFilters ? <CloseIcon height={24} /> : <MenuIcon height={24} />}
      <span>{showFilters ? 'Hide Filters' : 'Show Filters'}</span>
    </button>
  )
}

export default FilterToggle
